import { render, staticRenderFns } from "./CouponsInsert.vue?vue&type=template&id=3fa66df0&scoped=true&"
import script from "./CouponsInsert.vue?vue&type=script&lang=js&"
export * from "./CouponsInsert.vue?vue&type=script&lang=js&"
import style0 from "./CouponsInsert.vue?vue&type=style&index=0&id=3fa66df0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa66df0",
  null
  
)

export default component.exports